export {
    getFeaturedPortals,
    getHiddenPortals,
    isPortalReorderingChangeboardingEnabled,
} from './featuredAndSortedPortals';
